export const localStorageGetItem = (key) => {
  try {
    const local = localStorage.getItem(key);
    if (!local) {
      return null;
    }
    return JSON.parse(local);
  } catch (error) {
    console.error("Json parse error:", error);
    throw new Error("Failed to Json parse data");
  }
};

export const localStorageSetItem = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error("LocalStorage set item error:", error);
    throw new Error("Failed to LocalStorage set item");
  }
};

export const localStorageRemoveItem = (key, data) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("LocalStorage remove item error:", error);
    throw new Error("Failed to LocalStorage remove item");
  }
};
